// src/pages/Home.js
import React from 'react';
import '../styles/LittleChiefStyle.css';
import lukeImage from "../static/images/LukeLittleChiefLogo.png";

function Home() {
    return (
        <div className="home-container">
            <div>
                <img id="luke-home-image" src= {lukeImage} alt={"Luke Little Chief"}/>
            </div>
            <div className="home-text-container">
                <h3>Hip Hop Artist</h3>
                <h3>MC</h3>
                <h3>Apparel</h3>
            </div>
        </div>
    );
}

export default Home;